import { StreamActions } from "@hotwired/turbo"

StreamActions.reload_frame = function() {
  this.targetElements.forEach((frame) => {
    if (!frame.hasAttribute("src")) frame.setAttribute("src", window.location.href)
    frame.reload()
  })
}
